
class OtherInput {

    constructor($compile) {

        this.$compile = $compile;

        return {
            restrict: 'E',
            templateUrl: 'forms/other-input.html',
            compile: function (Elem, Attrs) {
                var keysToCopy = [
                  'ngModel',
                  'type',
                  'placeholder',
                  'name',
                  'label',
                  'pattern',
                  'required',
                  'minlength',
                  'maxlength',
                  'min',
                  'max',
                  'readonly'
                ];
                var $label = Elem.find('label');

                // copy attrs to the input
                Object.keys(Attrs).forEach(
                    function (key) {
                      if (key.indexOf('ng') === 0 || keysToCopy.indexOf(key) > -1) {
                        
                        Elem.find('input').attr(_.kebabCase(key), Attrs[key] || 1);
                      }
                    }
                );

                //add label and id
                if (Attrs['label']) $label.text(Attrs['label']);
                if (Attrs['name']) $label.attr('for', Attrs['name']);

            }
        };

    }

}


angular.module('cpm')
    .directive('otherInput', () => {
        'use strict';
        return new OtherInput();
    });
